import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_WS } from "./actionTypes";
import {
  registerWorkstationSuccessful,
  registerWorkstationFailed,
} from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationsAPI = getWorkstationsAPI();

// Is user register successfull then direct plot user in redux.
function* registerWS({ payload: { ws, history } }) {
  try {
    const response = yield call(
      workstationsAPI.newWorkstation,
      ws.wsname,
      ws.wspicking,
      ws.wstype,
      ws.wsbuffer,
      ws.wsmaxtasks,
      ws.inboundArea,
      ws.strategyInbound,
      ws.positions,
      ws.token
    );
    yield put(registerWorkstationSuccessful(response.message));
    history.push("/createworkstation");
  } catch (error) {
    yield put(registerWorkstationFailed(error));
  }
}

export function* watchWSRegister() {
  yield takeEvery(REGISTER_WS, registerWS);
}

function* registerWSSaga() {
  yield all([fork(watchWSRegister)]);
}

export default registerWSSaga;
